export default __webpack_public_path__ + "static/media/partnersBackgropund.e4c6a730.png";